import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const HCContainerLevelOne = styled.div`
  padding: 0 24px;
  margin: 48px auto;
  font-family: Outfit, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  width: 100%;
  @media (min-width: 768px) {
    max-width: 1200px;
    padding: 0 32px;
  }
  @media (min-width: 1024px) {
    max-width: 1400px;
  }
`

export const HCContainerLevelTwo = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;
  }
`

export const HCItemContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 28px 24px;
  border-radius: 16px;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  border: 1px solid #e5e7eb;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-color: #667eea;
    
    &::before {
      transform: scaleX(1);
    }
    
    .category-icon {
      transform: scale(1.1) rotate(5deg);
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
  }
`

export const HCIconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  
  .category-icon {
    font-size: 32px;
    color: #667eea;
    transition: all 0.3s ease;
  }
`

export const HCItemHeading = styled.div`
  font-weight: 600;
  font-size: 28px;
  text-align: center;
  margin-top: 3rem;
  margin-bottom: 1rem;
  color: #111827;
  @media (min-width: 768px) {
    font-size: 32px;
  }
`

export const HCItemHeadingH1 = styled.h1`
  font-weight: 700;
  font-size: 36px;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  color: #111827;
  letter-spacing: -0.02em;
  @media (min-width: 768px) {
    font-size: 48px;
    margin-top: 3rem;
  }
`

export const HCSubheading = styled.p`
  font-size: 18px;
  text-align: center;
  color: #6b7280;
  margin-bottom: 3rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`

export const HCItemText = styled.div`
  font-weight: ${(props) => (props?.heading ? '600' : '400')};
  margin-top: ${(props) => (props?.heading ? '0' : '12px')};
  font-size: ${(props) => (props?.heading ? '22px' : '15px')};
  line-height: ${(props) => (props?.heading ? '1.3' : '1.6')};
  color: ${(props) => (props?.heading ? '#111827' : '#6b7280')};
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => (props?.heading ? '2' : '3')};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const HCItemTalkToUsContainer = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  width: 100%;
  border-radius: 20px;
  margin: 4rem auto 0;
  padding: 40px 32px;
  color: #fff;
  max-width: 600px;
  box-shadow: 0 20px 25px -5px rgba(102, 126, 234, 0.3), 0 10px 10px -5px rgba(102, 126, 234, 0.2);
  
  @media (min-width: 768px) {
    padding: 48px 40px;
  }
`

export const HCTalkToUsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 32px;
`

export const HCItemTalkToUsIconContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  
  .MuiSvgIcon-root {
    font-size: 40px;
    color: #fff;
  }
`

export const HCTalkToUsContent = styled.div`
  flex: 1;
  
  h3 {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 8px 0;
    color: #fff;
  }
  
  p {
    font-size: 16px;
    margin: 0;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.5;
  }
`

export const HCTalkToUsActions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 32px;
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const HCItemTalkToUsALink = styled.a`
  background-color: rgba(255, 255, 255, 0.95);
  padding: 16px 24px;
  color: #667eea;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  
  &:hover {
    background-color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
  }
  
  .MuiSvgIcon-root {
    font-size: 28px;
  }
  
  div:last-child {
    font-size: 14px;
  }
`

export const HCTalkToUsFooter = styled.div`
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  
  a {
    color: #fff;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    transition: opacity 0.2s;
    
    &:hover {
      opacity: 0.8;
      text-decoration: underline;
    }
  }
`
